exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form > .row[data-v-50658160] {\n  margin-left: -10px;\n  margin-right: -10px;\n}\nform > .row > div[data-v-50658160] {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.form-group.operaciones ul.nav[data-v-50658160] {\n  padding: 3px;\n  background: #fff;\n  border-radius: 0.25rem;\n}\n.form-group.operaciones ul.nav > .nav-item > .nav-link[data-v-50658160] {\n  padding: 5px 15px;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n.form-group.operaciones ul.nav > .nav-item > .nav-link > .mdi[data-v-50658160] {\n  font-size: 18px;\n  margin-left: 5px;\n}", ""]);

// exports
